import { render, staticRenderFns } from "./PaginationTableComponent.vue?vue&type=template&id=3b4e8f7a&"
import script from "./PaginationTableComponent.vue?vue&type=script&lang=ts&"
export * from "./PaginationTableComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b4e8f7a')) {
      api.createRecord('3b4e8f7a', component.options)
    } else {
      api.reload('3b4e8f7a', component.options)
    }
    module.hot.accept("./PaginationTableComponent.vue?vue&type=template&id=3b4e8f7a&", function () {
      api.rerender('3b4e8f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/PaginationTableComponent.vue"
export default component.exports